<gl-popout-container #popout style="max-height: 0; overflow: hidden">
  <!--
    child nodes are positioned absolutely and have height. 
    overflow should be reset as required
  -->
</gl-popout-container>

<golden-layout-navigator></golden-layout-navigator>
<div class="golden-layout-target" nativeDesktopClass="desktop" #lm></div>
